import { views } from '@/v-shop/autoloader'

export default () => [
	{
		path: '/ai-search',
		name: 'ai-search',
		component: views.AiSearch,
	},
]

